module.exports = __webpack_public_path__ + "media/images/messages-cbf081b1450095139a3942300f3e76d7.svg";